import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

interface Breadcrumb {
    label: string;
    url: string;
    videoSrc: string;
}

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {
    breadcrumbs: Breadcrumb[] = [];

    // Mapa centralizado: path de la ruta -> video de lengua de señas para agregar un nuevo breadcrumb con video.
    private readonly breadcrumbVideos: Record<string, string> = {
        login: 'assets/accesibilidad/login/64. Autenticación - Iniciar sesión.mp4',
    };

    constructor(private router: Router, private route: ActivatedRoute) {}

    ngOnInit(): void {
        //Segun la ruta asigna el valor de miga de pan que se le asigno
        const root = this.router.routerState.snapshot.root;
        this.breadcrumbs = this.buildBreadcrumbsFromSnapshot(root);
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
            const root = this.router.routerState.snapshot.root;
            this.breadcrumbs = this.buildBreadcrumbsFromSnapshot(root);
        });
    }

    buildBreadcrumbsFromSnapshot(route: ActivatedRouteSnapshot, url: string = '', breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
        if (route.routeConfig && route.routeConfig.path) {
            let path = route.routeConfig.path;
            Object.keys(route.params).forEach((key) => {
                const value = route.params[key];
                path = path.replace(`:${key}`, value);
            });

            // 2. Construir URL real
            url += `/${path}`;
            const label = route.data['breadcrumb'];
            if (label) {
                breadcrumbs.push({
                    label,
                    url,
                    videoSrc: this.breadcrumbVideos[route.routeConfig.path] || '',
                });
            }
        }

        for (const child of route.children) {
            this.buildBreadcrumbsFromSnapshot(child, url, breadcrumbs);
        }

        return breadcrumbs;
    }
}